import { useCallback, useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'

import { ScriptStatus, useScript } from '../../app/hooks/useScript'
import getLanguageCode from '../../app/utils/getLanguageCode'
import { GoogleMapsAPIUrl } from '../../app/constants'

export default function usePlacesAutoComplete() {
  const { lang } = useTranslation()

  const scriptStatus = useScript(GoogleMapsAPIUrl)

  const fetchPredictions = useCallback(
    async (query: string) => {
      if (window.google && window.google.maps?.places?.AutocompleteSuggestion) {
        const results =
          await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
            {
              input: query,
              includedRegionCodes: ['se', 'no'],
              language: getLanguageCode(lang),
            },
          )

        return results.suggestions
      }

      return []
    },
    [lang],
  )

  useEffect(() => {
    if (scriptStatus === ScriptStatus.Ready) {
      if (!window.google) {
        throw new Error('Google Maps JavaScript API library must be loaded.')
      }

      if (!window.google.maps.places) {
        throw new Error(
          'Google Maps Places library must be loaded. Please add `libraries=places` to the src URL',
        )
      }
    }
  }, [scriptStatus])

  return {
    fetchPredictions,
  }
}
